import type { JSX } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { ArrowUpRightIcon, IconButton } from '@buffer-mono/popcorn'

import { useInsightsUrl } from '~publish/components/MainSidebar/hooks/useInsightsUrl'

import { useTrackTakeawayCtaClicked } from '../../hooks/useTrackTakeawayCtaClicked'
import type { TakeawayCtaTrackingContext } from '../../hooks/useTrackTakeawayCtaClicked'

import styles from './Takeaways.module.css'

const LABEL = 'More Insights'

/**
 * Opens the Insights page of the one channel a takeaway concerns.
 *
 * `useInsightsUrl` carries the period the customer already picked, so the
 * channel opens on the same range instead of the default one.
 */
export function TakeawayInsightsLink({
  channelId,
  channelName,
  trackingContext,
}: {
  channelId: string
  channelName: string
  trackingContext: TakeawayCtaTrackingContext
}): JSX.Element {
  const trackCta = useTrackTakeawayCtaClicked()
  const insightsUrl = useInsightsUrl(channelId)
  const accessibleLabel = `${LABEL} for ${channelName}`
  const handleClick = (): void => {
    trackCta.digIntoInsights({ ...trackingContext, ctaLabel: LABEL })
  }

  return (
    <IconButton
      as={RouterLink}
      to={insightsUrl}
      variant="tertiary"
      size="small"
      className={styles.insightsIconLink}
      label={accessibleLabel}
      tooltip={LABEL}
      onClick={handleClick}
    >
      <ArrowUpRightIcon size="xsmall" />
    </IconButton>
  )
}
